// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1-enf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__Fk4R2"};